import { type FC, useState } from "react"
import styled from "styled-components"

import CommunityProfileAvatar from "@forento/shared-client/components/CommunityProfileAvatar"
import { type CommunityPostReaction } from "@forento/shared/models/community"

import ProfilePopup from "../ProfilePopup"

const Reaction: FC<{ reaction: CommunityPostReaction }> = ({ reaction }) => {
	const [authorElement, setAuthorElement] = useState<HTMLDivElement | null>(null)

	return (
		<Container>
			<ProfilePopup targetElement={authorElement} profileId={reaction.profile.id} />
			<CommunityProfileAvatar size={32} profile={reaction.profile} ref={setAuthorElement} />
			<p key={reaction.profile.id}>
				{reaction.profile.firstName} {reaction.profile.lastName}
			</p>
		</Container>
	)
}

const Container = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
`

export default Reaction
